import FixedOrFloatingEditor from './FixedOrFloatingEditor'

export default FixedOrFloatingEditor
